module.exports = __webpack_public_path__ + "static/media/kalume108.2a99beea.jpg";